import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import ActionBar from '../../components/ActionBar';
import Fieldset from '../Fieldset';
import Input from '../Input';
import { Content } from './styles';

function PaymentInfo({ t, data, setData, errors }) {
  const [nextDisabled, disableNext] = useState(true);
  const [secondAddress, setSecondAddress] = useState(false);

  useEffect(() => {
    disableNext(false);
  });

  function handleNext() {
    return true;
  }

  function handlePrev() {
    return true;
  }

  function handleCheckEnableEAMInvoice() {
    setSecondAddress(!data.enableEamElectronicInvoice);
    let newData = {
      enableEamElectronicInvoice: !data.enableEamElectronicInvoice
    };

    setData(newData);
  }

  function handleChange({ target: { name, value } }) {
    setData({ [name]: value });
  }

  return (
    <div>
      <Content>
        <Fieldset legend={t('form.legends.paymentInfo')}>
          <div>
            <Input
              id="invoiceEmail"
              type="text"
              value={data.invoiceEmail}
              error={errors.invoiceEmail}
              onChange={handleChange}
            />
          </div>
          <div className="form-check">
            <input
              id="enableEamElectronicInvoice"
              type="checkbox"
              className="form-check-input"
              onChange={handleCheckEnableEAMInvoice}
              checked={data.enableEamElectronicInvoice}
            />
            <label
              htmlFor="enableEamElectronicInvoice"
              className="form-check-label"
            >
              {t('form.enableEamElectronicInvoice.label')}
            </label>
          </div>
          {secondAddress ? (
            <div>
              <Input
                id="paymentRemindersEmail"
                type="text"
                value={data.paymentRemindersEmail}
                error={errors.paymentRemindersEmail}
                onChange={handleChange}
              />
            </div>
          ) : null}
        </Fieldset>
      </Content>

      <ActionBar
        onPrev={handlePrev}
        onNext={handleNext}
        nextDisabled={nextDisabled}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  data: state.signup.data,
  errors: state.signup.errors
});

const mapDispatchToProps = dispatch => ({
  setData: data => dispatch({ type: 'SET_DATA', payload: data })
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(PaymentInfo)
);
